import { GameFullHouseProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameFullHouseProperties";
/**
 * FullHouseLandscapeProperties.ts
 */
export class FullHouseLandscapeProperties extends GameFullHouseProperties {
    constructor() {
        super();
        this.position.set(973, 468);
    }
}
//# sourceMappingURL=FullHouseLandscapeProperties.js.map